import { PageTitle } from '_metronic/layout/core'

import TabsButtonGroup from 'Presentation/Components/Tabs/ButtonGroup'
import StatisticZone from './Components/StatisticZone'
import { ClientSideTable } from 'Presentation/Components/Table'

import useViewModel from './ViewModel'

//////////
// View //
//////////

const BillingOEM = () => {
	const { stat, data, setCurrentTab, TABLE_CONFIGS } = useViewModel()

	return (
		<ViewPageTitle>
			{/* Tabs */}
			<TabsButtonGroup
				changeTab={setCurrentTab}
				tabNames={['ภาพรวมบัญชี OEM']}
				tabContents={[
					<div className="card border border-kumopack-grey-200 mt-5">
						<div className="card-body">
							<div className="row">
								<div className="col-12">
									<StatisticZone
										stat1={stat?.sumStatus50}
										stat2={stat?.sumStatus60_70}
										stat3={stat?.sumStatus70}
									/>
								</div>

								{/* Table */}
								<div className="col-12">
									<div className="card bg-transparent">
										{/* begin:: Header */}
										<div className="card-header border-0" style={{ padding: '1.25rem' }}>
											<div className="d-flex flex-row justify-content-between align-items-center w-100 mt-3">
												<div>
													<div
														className="d-flex flex-row align-items-center"
														style={{ columnGap: '12px' }}>
														<div className="fs-4 fw-bold text-kumopack-grey-900">
															Billing and Invoicing
														</div>
													</div>

													<p className="text-kumopack-grey-600">
														Pick an account plan that fits your workflow.
													</p>
												</div>

												<div>
													{/* <button
														className="btn btn-sm white-button text-kumopack-grey-700 fw-bold"
														id="downloadBtn">
														<img
															alt="download_img"
															src="/media/icons/kumopack/download-cloud-02.svg"
															style={{ marginRight: '4px' }}
														/>
														Download All
													</button> */}
												</div>
											</div>
										</div>
										{/* end:: Header */}

										{/* begin:: Body */}
										<div className="card-body px-0 py-2 border border-kumopack-grey-200 border-radius-16px">
											<ClientSideTable
												pagination
												isGrey
												items_per_page={10}
												columns={TABLE_CONFIGS}
												data={data}
											/>
										</div>
										{/* end:: Body */}
									</div>
								</div>
							</div>
						</div>
					</div>,
					<></>,
				]}
			/>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'Billing',
						path: '/billing',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'OEM',
						path: '#',
						isActive: true,
						isSeparator: false,
					},
				]}>
				ภาพรวมบัญชี OEM
			</PageTitle>

			{children}
		</>
	)
}

export default BillingOEM
